import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Seo } from "@/components/Seo";
import { PageHero } from "@/components/shared";

export default function Unsubscribe() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const [state, setState] = useState("loading"); // loading | done | error | missing

  useEffect(() => {
    if (!token) {
      setState("missing");
      return;
    }
    api
      .get(`/newsletter/unsubscribe?token=${encodeURIComponent(token)}`)
      .then(() => setState("done"))
      .catch(() => setState("error"));
  }, [token]);

  return (
    <>
      <Seo title="Désinscription — La lettre BENZENATI" description="Gérer votre désinscription à La lettre BENZENATI." path="/desinscription" />
      <PageHero label="La lettre BENZENATI" title="Désinscription" testid="unsubscribe-hero" />

      <section className="mx-auto max-w-3xl px-6 py-16 lg:py-24" data-testid="unsubscribe-content">
        {state === "loading" && <p className="text-bz-slate">Traitement en cours…</p>}
        {state === "done" && (
          <div data-testid="unsubscribe-done">
            <p className="text-lg leading-relaxed text-bz-slate">
              Votre adresse a bien été désinscrite de La lettre BENZENATI. Vous ne recevrez plus nos envois.
            </p>
            <Link to="/" className="mt-8 inline-flex text-sm text-bz-petrol underline underline-offset-4">
              Retour à l'accueil
            </Link>
          </div>
        )}
        {state === "error" && (
          <p className="text-lg leading-relaxed text-bz-slate" data-testid="unsubscribe-error">
            Ce lien de désinscription est invalide ou a déjà été utilisé. Pour toute question, écrivez à{" "}
            <a href="mailto:consulting@benzenati.com" className="underline underline-offset-2">consulting@benzenati.com</a>.
          </p>
        )}
        {state === "missing" && (
          <p className="text-lg leading-relaxed text-bz-slate" data-testid="unsubscribe-missing">
            Aucun lien de désinscription n'a été fourni. Utilisez le lien présent en bas de chaque lettre reçue, ou écrivez à{" "}
            <a href="mailto:consulting@benzenati.com" className="underline underline-offset-2">consulting@benzenati.com</a>.
          </p>
        )}
      </section>
    </>
  );
}
